// import React, { useEffect, useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import Button from '../../../components/ui/Button';
// import Input from '../../../components/ui/Input';
// import UseEmployeeHook from 'hooks/UseEmployeeHook';
// import { active } from 'd3';

// const AddEmployeeModal = ({ isOpen, onClose ,employee }) => {
//   // console.log(employee)
//   const {updateEmployee} = UseEmployeeHook();
//   // const [formData, setFormData] = useState({
//   //   _id: employee?._id,
//   //   name: employee?.name || '',
//   //   email: employee?.email || '',
//   //   // phone: '',
//   //   whatsappNumber: employee?.mobile || '',
//   //   role: 'employee',
//   //   // department: '',
//   //   // billingLimit: '',
//   //   // accessLevel: 'basic',
//   //   // permissions: {
//   //   //   canCreateBills: false,
//   //   //   canViewReports: false,
//   //   //   canManageProducts: false,
//   //   //   canAccessFinance: false
//   //   // }
//   // });

//   const [formData, setFormData] = useState({
//     _id: '',
//     name: '',
//     email: '',
//     whatsappNumber: '',
//     role: 'employee',
//     active : true
//   });
//    useEffect(() => {
//     if (employee) {
//       setFormData({
//         _id: employee?._id || '',
//         name: employee?.name || '',
//         email: employee?.email || '',
//         whatsappNumber: employee?.mobile || '',
//         role: employee?.role || 'employee',
//         active: employee?.active 
//       });
//     } else {
//       // If adding a new employee, reset form
//       setFormData({
//         _id: '',
//         name: '',
//         email: '',
//         whatsappNumber: '',
//         role: 'employee'
//       });
//     }
//   }, [employee, isOpen]);
//   const {createEmployee} = UseEmployeeHook();
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleInputChange = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: value
//     }));
    
//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors(prev => ({
//         ...prev,
//         [field]: ''
//       }));
//     }
//   };

//   const handlePermissionChange = (permission, checked) => {
//     setFormData(prev => ({
//       ...prev,
//       permissions: {
//         ...prev.permissions,
//         [permission]: checked
//       }
//     }));
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.name.trim()) {
//       newErrors.name = 'Full name is required';
//     }

//     if (!formData.email.trim()) {
//       newErrors.email = 'Email address is required';
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = 'Please enter a valid email address';
//     }

//     // if (!formData.phone.trim()) {
//     //   newErrors.phone = 'Phone number is required';
//     // }

//     if (!formData.whatsappNumber.trim()) {
//       newErrors.whatsappNumber = 'WhatsApp number is required for authentication';
//     }

//     // if (!formData.department.trim()) {
//     //   newErrors.department = 'Department selection is required';
//     // }

//     // if (!formData.billingLimit || parseFloat(formData.billingLimit) <= 0) {
//     //   newErrors.billingLimit = 'Please enter a valid billing limit';
//     // }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }

//     setIsSubmitting(true);
    
//     try {
//       // Simulate API call
//       await new Promise(resolve => setTimeout(resolve, 1500));
      
//       const newEmployee = {
//         id: Date.now(),
//         ...formData,
//         billingLimit: parseFloat(formData.billingLimit),
//         billingUsed: 0,
//         status: 'active',
//         employeeId: `EMP${String(Date.now()).slice(-6)}`,
//         avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${formData.name}`,
//         lastLogin: new Date(),
//         createdAt: new Date()
//       };
      
//       // onSubmit(newEmployee);
// if(employee){   

//   await updateEmployee(formData);  
// }else{
//   await createEmployee(formData);
  
// }
//       handleClose();
//     } catch (error) {
//       console.error('Error creating employee:', error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleClose = () => {
//     setFormData({
//       _id: '',
//       name: '',
//       email: '',
//       // phone: '',
//       whatsappNumber: '',
//       role: 'employee',
//       // department: '',
//       // billingLimit: '',
//       // accessLevel: 'basic',
//       // permissions: {
//       //   canCreateBills: false,
//       //   canViewReports: false,
//       //   canManageProducts: false,
//       //   canAccessFinance: false
//       // }
//     });
//     setErrors({});
//     setIsSubmitting(false);
//     onClose();
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-1200 overflow-y-auto">
//       <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
//         <div className="fixed inset-0 transition-opacity bg-black/50" onClick={handleClose} />
        
//         <div className="inline-block w-full max-w-2xl my-8 overflow-hidden text-left align-middle transition-all transform bg-card shadow-modal rounded-lg border border-border">
//           {/* Header */}
//           <div className="flex items-center justify-between p-6 border-b border-border">
//             <div>
//               <h3 className="text-lg font-semibold text-foreground">{employee ? 'Edit Employee' : ' Add New Employee'}</h3>
//               <p className="text-sm text-muted-foreground mt-1">
//                 { employee ? 'Update employee details' : '  Create a new employee account to access the system' }
//               </p>
//             </div>
//             <Button
//               variant="ghost"
//               size="icon"
//               onClick={handleClose}
//               disabled={isSubmitting}
//             >
//               <Icon name="X" size={20} />
//             </Button>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit} className="p-6 space-y-6">
//             {/* Basic Information */}
//             <div className="space-y-4">
//               <h4 className="text-sm font-medium text-foreground">Basic Information</h4>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <Input
//                   label="Full Name"
//                   type="text"
//                   placeholder="Enter employee's full name"
//                   value={formData.name}
//                   onChange={(e) => handleInputChange('name', e.target.value)}
//                   error={errors.name}
//                   required
//                 />
                
//                 <Input
//                   label="Email Address"
//                   type="email"
//                   placeholder="employee@company.com"
//                   value={formData.email}
//                   onChange={(e) => handleInputChange('email', e.target.value)}
//                   error={errors.email}
//                   required
//                 />
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {/* <Input
//                   label="Phone Number"
//                   type="tel"
//                   placeholder="+1 (555) 123-4567"
//                   value={formData.phone}
//                   onChange={(e) => handleInputChange('phone', e.target.value)}
//                   error={errors.phone}
//                   required
//                 /> */}
                
//                 <Input
//                   label="WhatsApp Number"
//                   type="tel"
//                   placeholder="6523456789"
//                   description="Used for OTP authentication"
//                   value={formData.whatsappNumber}
//                   onChange={(e) => handleInputChange('whatsappNumber', e.target.value)}
//                   error={errors.whatsappNumber}
//                   required
//                 />
//               </div>
//             </div>

//             {/* Role & Department */}
//             <div className="space-y-4">
//               <h4 className="text-sm font-medium text-foreground">Role </h4>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm font-medium text-foreground mb-2">
//                     Role <span className="text-destructive">*</span>
//                   </label>
//                   <select
//                     value={formData.role}
//                     onChange={(e) => handleInputChange('role', e.target.value)}
//                     className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                   >
//                     <option defaultChecked value="employee">Employee</option>
                   
//                   </select>
//                 </div>
                
//                 {/* <div>
//                   <label className="block text-sm font-medium text-foreground mb-2">
//                     Department <span className="text-destructive">*</span>
//                   </label>
//                   <select
//                     value={formData.department}
//                     onChange={(e) => handleInputChange('department', e.target.value)}
//                     className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                   >
//                     <option value="">Select Department</option>
//                     <option value="sales">Sales</option>
//                     <option value="marketing">Marketing</option>
//                     <option value="operations">Operations</option>
//                     <option value="finance">Finance</option>
//                     <option value="hr">Human Resources</option>
//                     <option value="it">IT Support</option>
//                   </select>
//                   {errors.department && (
//                     <p className="text-sm text-destructive mt-1">{errors.department}</p>
//                   )}
//                 </div> */}
//               </div>
//             </div>

//             {/* Billing & Access */}
//             {/* <div className="space-y-4">
//               <h4 className="text-sm font-medium text-foreground">Billing & Access Control</h4>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <Input
//                   label="Billing Limit"
//                   type="number"
//                   placeholder="1000.00"
//                   value={formData.billingLimit}
//                   onChange={(e) => handleInputChange('billingLimit', e.target.value)}
//                   error={errors.billingLimit}
//                   description="Maximum amount employee can bill"
//                   required
//                 />
                
//                 <div>
//                   <label className="block text-sm font-medium text-foreground mb-2">
//                     Access Level
//                   </label>
//                   <select
//                     value={formData.accessLevel}
//                     onChange={(e) => handleInputChange('accessLevel', e.target.value)}
//                     className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                   >
//                     <option value="basic">Basic Access</option>
//                     <option value="standard">Standard Access</option>
//                     <option value="advanced">Advanced Access</option>
//                   </select>
//                 </div>
//               </div>
//             </div> */}

//             {/* Permissions */}
//             {/* <div className="space-y-4">
//               <h4 className="text-sm font-medium text-foreground">Permissions</h4>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={formData.permissions.canCreateBills}
//                     onChange={(e) => handlePermissionChange('canCreateBills', e.target.checked)}
//                     className="rounded border-border text-primary focus:ring-primary"
//                   />
//                   <div>
//                     <span className="text-sm font-medium text-foreground">Create Bills</span>
//                     <p className="text-xs text-muted-foreground">Allow employee to create billing entries</p>
//                   </div>
//                 </label>
                
//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={formData.permissions.canViewReports}
//                     onChange={(e) => handlePermissionChange('canViewReports', e.target.checked)}
//                     className="rounded border-border text-primary focus:ring-primary"
//                   />
//                   <div>
//                     <span className="text-sm font-medium text-foreground">View Reports</span>
//                     <p className="text-xs text-muted-foreground">Access to billing and performance reports</p>
//                   </div>
//                 </label>
                
//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={formData.permissions.canManageProducts}
//                     onChange={(e) => handlePermissionChange('canManageProducts', e.target.checked)}
//                     className="rounded border-border text-primary focus:ring-primary"
//                   />
//                   <div>
//                     <span className="text-sm font-medium text-foreground">Manage Products</span>
//                     <p className="text-xs text-muted-foreground">Add, edit, and remove products</p>
//                   </div>
//                 </label>
                
//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={formData.permissions.canAccessFinance}
//                     onChange={(e) => handlePermissionChange('canAccessFinance', e.target.checked)}
//                     className="rounded border-border text-primary focus:ring-primary"
//                   />
//                   <div>
//                     <span className="text-sm font-medium text-foreground">Access Finance</span>
//                     <p className="text-xs text-muted-foreground">View financial data and transactions</p>
//                   </div>
//                 </label>
//               </div>
//             </div> */}

//             {/* Actions */}
//             <div className="flex items-center justify-end space-x-3 pt-6 border-t border-border">
//               <Button
//                 type="button"
//                 variant="outline"
//                 onClick={handleClose}
//                 disabled={isSubmitting}
//               >
//                 Cancel
//               </Button>
//              { employee ? (<Button
//                 type="submit"
//                 loading={isSubmitting}
//                 iconName="UserPlus"
//                 iconPosition="left"
//                 iconSize={16}
//               >
//                 {isSubmitting  ? "Updating..." : "Update Employee" }
//               </Button>): (<Button
//                 type="submit"
//                 loading={isSubmitting}
//                 iconName="UserPlus"
//                 iconPosition="left"
//                 iconSize={16}
//               >
//                 {isSubmitting  ? "Adding..." : "Add Employee" }
//               </Button>)}
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddEmployeeModal;



//  // permission added in formData state and handlePermissionChange 


import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import UseEmployeeHook from 'hooks/UseEmployeeHook';

const AddEmployeeModal = ({ isOpen, onClose, employee }) => {
  const { updateEmployee, createEmployee } = UseEmployeeHook();

  const [formData, setFormData] = useState({
    _id: '',
    name: '',
    email: '',
    whatsappNumber: '',
    role: 'employee',
    active: true,
    permissions: {
      canAddProduct: false,
      canAddService: false,
      canAddCombo: false
    }
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (employee) {
      setFormData({
        _id: employee?._id || '',
        name: employee?.name || '',
        email: employee?.email || '',
        whatsappNumber: employee?.mobile || '',
        role: employee?.role || 'employee',
        active: employee?.active ?? true,
        permissions: employee?.permissions || {
          canAddProduct: false,
          canAddService: false,
          canAddCombo: false
        }
      });
    } else {
      setFormData({
        _id: '',
        name: '',
        email: '',
        whatsappNumber: '',
        role: 'employee',
        active: true,
        permissions: {
          canAddProduct: false,
          canAddService: false,
          canAddCombo: false
        }
      });
    }
  }, [employee, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: '' }));
  };

  const handlePermissionChange = (permission, checked) => {
    setFormData(prev => ({
      ...prev,
      permissions: { ...prev.permissions, [permission]: checked }
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Full name is required';
    if (!formData.email.trim()) newErrors.email = 'Email address is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = 'Please enter a valid email address';
    if (!formData.whatsappNumber.trim())
      newErrors.whatsappNumber = 'WhatsApp number is required for authentication';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      if (employee) {
        await updateEmployee(formData);
      } else {
        await createEmployee(formData);
      }
      handleClose();
    } catch (error) {
      console.error('Error saving employee:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setFormData({
      _id: '',
      name: '',
      email: '',
      whatsappNumber: '',
      role: 'employee',
      active: true,
      permissions: {
        canAddProduct: false,
        canAddService: false,
        canAddCombo: false
      }
    });
    setErrors({});
    setIsSubmitting(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-1200 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-black/50" onClick={handleClose} />
        
        <div className="inline-block w-full max-w-2xl my-8 overflow-hidden text-left align-middle transition-all transform bg-card shadow-modal rounded-lg border border-border">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div>
              <h3 className="text-lg font-semibold text-foreground">
                {employee ? 'Edit Employee' : 'Add New Employee'}
              </h3>
              <p className="text-sm text-muted-foreground mt-1">
                {employee ? 'Update employee details' : 'Create a new employee account to access the system'}
              </p>
            </div>
            <Button variant="ghost" size="icon" onClick={handleClose} disabled={isSubmitting}>
              <Icon name="X" size={20} />
            </Button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            {/* Basic Info Section */}
            <div className="space-y-4">
              <h4 className="text-sm font-medium text-foreground">Basic Information</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                  label="Full Name"
                  type="text"
                  placeholder="Enter employee's full name"
                  value={formData.name}
                  onChange={e => handleInputChange('name', e.target.value)}
                  error={errors.name}
                  required
                />
                <Input
                  label="Email Address"
                  type="email"
                  placeholder="employee@company.com"
                  value={formData.email}
                  onChange={e => handleInputChange('email', e.target.value)}
                  error={errors.email}
                  required
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Input
                  label="WhatsApp Number"
                  type="tel"
                  placeholder="9988776655"
                  description="Used for OTP authentication"
                  value={formData.whatsappNumber}
                  onChange={e => handleInputChange('whatsappNumber', e.target.value)}
                  error={errors.whatsappNumber}
                  required
                />
              </div>
            </div>

            {/* Role */}
            <div className="space-y-4">
              <h4 className="text-sm font-medium text-foreground">Role</h4>
              <select
                value={formData.role}
                onChange={e => handleInputChange('role', e.target.value)}
                className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              >
                <option value="employee">Employee</option>
              </select>
            </div>

            {/* ✅ Permissions Section */}
            <div className="space-y-4">
              <h4 className="text-sm font-medium text-foreground">Access Permissions</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <label className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    checked={formData.permissions.canAddProduct}
                    onChange={e => handlePermissionChange('canAddProduct', e.target.checked)}
                    className="rounded border-border text-primary focus:ring-primary"
                  />
                  <span className="text-sm text-foreground">Can Add Products</span>
                </label>

                <label className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    checked={formData.permissions.canAddService}
                    onChange={e => handlePermissionChange('canAddService', e.target.checked)}
                    className="rounded border-border text-primary focus:ring-primary"
                  />
                  <span className="text-sm text-foreground">Can Add Services</span>
                </label>

                <label className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    checked={formData.permissions.canAddCombo}
                    onChange={e => handlePermissionChange('canAddCombo', e.target.checked)}
                    className="rounded border-border text-primary focus:ring-primary"
                  />
                  <span className="text-sm text-foreground">Can Add Combos</span>
                </label>
              </div>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-end space-x-3 pt-6 border-t border-border">
              <Button type="button" variant="outline" onClick={handleClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button type="submit" loading={isSubmitting} iconName="UserPlus" iconPosition="left" iconSize={16}>
                {isSubmitting
                  ? employee
                    ? 'Updating...'
                    : 'Adding...'
                  : employee
                  ? 'Update Employee'
                  : 'Add Employee'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEmployeeModal;
